import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { useAuth } from '../AuthContext';

export default function Login() {
    const baseURL = process.env.REACT_APP_BASE_URL;
    const [isUsernameValid, setIsUsernameValid] = useState(true);
    const [isPasswordValid, setIsPasswordValid] = useState(true);
    const { login } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    
    const [formData, setFormData] = useState({
        email: '',
        password: '',

    });

    const [captcha, setCaptcha] = useState(generateCaptcha());
    const [captchaInput, setCaptchaInput] = useState('');
    const [isCaptchaValid, setIsCaptchaValid] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = DOMPurify.sanitize(value);

        setFormData({
            ...formData,
            [name]: sanitizedValue,
        });

        if (name === 'email') setIsUsernameValid(sanitizedValue.length >= 5);
        if (name === 'password') setIsPasswordValid(sanitizedValue.length >= 8);
    };

    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    function generateCaptcha() {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        return Array.from({ length: 6 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
    }

    const handleCaptchaChange = (e) => {
        setCaptchaInput(DOMPurify.sanitize(e.target.value));
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        console.log('Login attempt with:', formData);


        if (!isUsernameValid) {
            alert('Username should be at least 5 characters long.');
            return;
        }
        if (!isPasswordValid) {
            alert('Password should be at least 8 characters long.');
            return;
        }
        if (captchaInput !== captcha) {
            alert('Incorrect CAPTCHA. Please try again.');
            setIsCaptchaValid(false);
            setCaptcha(generateCaptcha());
            setCaptchaInput('');
            return;
        }

        setIsLoading(true);

        try {
            const response = await fetch(`${baseURL}/login`, {
                method: 'POST',
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: formData.email,
                    password: formData.password,
                }),
            });

            const result = await response.json();

            if (response.ok) {
                const { access_token, refresh_token, user } = result;

                // Store tokens and user ID in localStorage
                localStorage.setItem('authToken', access_token);
                localStorage.setItem('refreshToken', refresh_token);
                localStorage.setItem('userid', user.userid);

                login();
                window.location.href = "/home";
            } else {
                setErrorMessage(result.detail || 'Login Failed'); // Set error message from response
            }
        } catch (error) {
            setErrorMessage('An error occurred. Please try again.');
        }
        finally {
            setIsLoading(false);
        }
    };


    const handleForgot = async (e) => {
        e.preventDefault();

        console.log('Login attempt with:', formData);


        setIsLoading(true);

        try {
            const response = await fetch(`${baseURL}/password-reset-request`, {
                method: 'POST',
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: formData.email,
                }),
            });

            const result = await response.json();

            if (response.ok) {
                const { token } = result;

                // Store tokens and user ID in localStorage
                localStorage.setItem('authToken', token);
                window.location.href = "/reset_password";
            } else {
                setErrorMessage(result.detail || 'Request Failed'); // Set error message from response
            }
        } catch (error) {
            setErrorMessage('An error occurred. Please try again.');
        }
        finally {
            setIsLoading(false);
        }
    };




    return (
        <>
            <section className="user-form-part">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4">
                            <div className="user-form-card">
                                <div className="user-form-title">
                                    <h2>Welcome</h2>
                                    <p>Enter your credentials to access your account</p>
                                </div>
                                <div className="user-form-group">
                                    <form onSubmit={handleLogin} className="user-form">
                                        <div className="form-group">
                                            <input type="email" className="form-control" name="email" onChange={handleChange} placeholder='Enter email' required autoComplete="current-password" />
                                        </div>
                                        <div className="form-group">
                                            <input type={showPassword ? 'text' : 'password'} id="password" name="password" className="form-control" onChange={handleChange} placeholder='Enter Password' required autoComplete="current-password" />
                                            <span toggle="#password" className={`far fa-fw ${showPassword ? 'fa-eye' : 'fa-eye-slash'} eye-icon toggle-password`} onClick={togglePasswordVisibility}></span>
                                        </div>
                                        <div className="form-group capcha-text">
                                            <label className=''><strong>{captcha}</strong></label>
                                            <input type="text" className="form-control" value={captchaInput} onChange={handleCaptchaChange} placeholder="Enter CAPTCHA here" required />

                                        </div>
                                        {!isCaptchaValid && <small style={{ color: 'red' }}>Incorrect CAPTCHA, please try again.</small>}
                                        {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}
                                        <div className='forgot-password'>
                                            <NavLink data-bs-toggle="modal" data-bs-target="#forgot-password">Forgot Password</NavLink>
                                        </div>
                                        <div className="col-md-12 text-center">
                                            <button
                                                type="submit"
                                                className='btn-6 view-all-btnn mt-3 text-capitalize'
                                                disabled={isLoading}
                                            >
                                                {isLoading ? <div class="spinner-border" role="status">
                                                    <span class="sr-only">Loading...</span>
                                                </div> : 'Sign In'}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="user-form-remind">
                                <p>Don't have any account? <NavLink to="/create_account">Create a new account</NavLink></p>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="modal fade set-md-width" id="forgot-password" tabindex="-1" aria-labelledby="forgot-password" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                        <button class="modal-close icofont-close"  data-bs-dismiss="modal" aria-label="Close"></button>
                            <div class="modal-body">
                                <div className='row justify-content-center'>
                                    <div className='col-md-10'>

                                        <div className="user-form-title">
                                            <h2>Forgot Password</h2>
                                        </div>
                                        <div className="user-form-group">
                                            <form onSubmit={handleForgot} className="user-form">
                                                <div className="form-group">
                                                    <input type="email" className="form-control" name="email" onChange={handleChange} placeholder='Enter email' required autoComplete="current-password" />
                                                </div>

                                                <div className="col-md-12 text-center">
                                                    <button
                                                        type="submit"
                                                        className='btn-6 view-all-btnn mt-3 text-capitalize'
                                                        disabled={isLoading}
                                                    >
                                                        {isLoading ? <div class="spinner-border" role="status">
                                                            <span class="sr-only">Loading...</span>
                                                        </div> : 'Forgot Password'}
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
